const config = {
  environment: process.env.REACT_APP_ENVIRONMENT,
  APIUrl: process.env.REACT_APP_API_URL,
  BlobURL: process.env.REACT_APP_BLOB_URL
};

export { config };
